module.exports = __webpack_public_path__ + "static/media/iStock-1047076654.7c7805fb.jpg";